import React from "react";
import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";


const Users = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [flag, setFlag] = useState(false);
  const [userName, setUserName] = useState("");
   const [userId, setUserId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [password, setPassword] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");
  const [emailId, setEmailId] = useState("");
  const [gender, setGender] = useState("");
  const [visibility, setVisibility] = useState("");
  const [isActive, setIsActive] = useState("");

  const [usersData, setUsersData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [schemeData, setSchemeData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [userTypeData, setUserTypeData] = useState([]);
  const [userRoleData, setUserRoleData] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [subDistrictData, setSubDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [villageData, setVillageData] = useState([]);
  const [insuranceCompanyData, setInsuranceData] = useState([])
 

  const [insuranceCompanyValue, setInsuranceCompanyValue] = useState("")
  const [departmentValue, setDepartmentValue] = useState("");
  const [schemeValue, setSchemeValue] = useState("");
  const [designationValue, setDesignationValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [districtValue, setDistrictValue] = useState("");
  const [subDistrictValue, setSubDistrictValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [villageValue, setVillageValue] = useState("");
  const [userTypeValue, setUserTypeValue] = useState("");
  const [userRoleValue, setUserRoleValue] = useState("");
  const [userCode, setUserCode] = useState("");
  const [otp, setOtp] = useState("");
 const [OTPSend, setOTPSend] = useState(false);
 const [mobileOTP, setMobileOTP] = useState("")
 const [mobileVerify, setMobileVerify] = useState(false);
  const [invalid, setInValid] = useState("")

  const [level, setLevel] = useState(sessionStorage.getItem("orgTypeCodeGlobal"))

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/users`
      );
      setUsersData(result.data.dataContent);
    };
    fetchData();
    fetchDataInsurance();
  }, []);

  const fetchDataInsurance = async () => {
    const result = await axios(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/insurance`
    );
    setInsuranceData(result.data.dataContent);
  };

  useEffect(() => {
    if (flag == true) {
      fetchData2();
    }
    
  }, [flag]);

 

  useEffect(() => { 

    if(sessionStorage.getItem("userTypeCodeGlobal") === "1") {
   
      document.getElementById("District").style.display = "none";
      // document.getElementById("subDistrict").style.display = "none";
      document.getElementById("Block").style.display = "none";
      document.getElementById("DistrictLabel").style.display = "none";
      // document.getElementById("subDistrictLabel").style.display = "none";
      document.getElementById("BlockLabel").style.display = "none";

      var x = document.getElementById("userType");

      if(sessionStorage.getItem("InsuranceCode")) {
        setInsuranceCompanyValue(sessionStorage.getItem("InsuranceCode"))
      document.getElementById("Insurance").disabled = true;
     
      var option = document.createElement("option"); 
      option.text = "State";
      option.value = "2"
      x.add(option);
  
      }

      if(sessionStorage.getItem("InsuranceCode") === "") {
        var option = document.createElement("option"); 
        option.text = "State";
        option.value = "2"
        x.add(option);

      }

  

    } else if(sessionStorage.getItem("userTypeCodeGlobal") === "2") {
    
      getStates()
    handleState(Number(sessionStorage.getItem("stateNameGlobal")))

      setStateValue(sessionStorage.getItem("stateNameGlobal"))
      document.getElementById("State").disabled = true;
      var x = document.getElementById("userType");
      var option = document.createElement("option"); 
      option.text = "District";
      option.value = "3"
      x.add(option);

   


        // document.getElementById("subDistrict").style.display = "none";
      document.getElementById("Block").style.display = "none";
      // document.getElementById("subDistrictLabel").style.display = "none";
      document.getElementById("BlockLabel").style.display = "none";

      if(sessionStorage.getItem("InsuranceCode")) {
        setInsuranceCompanyValue(sessionStorage.getItem("InsuranceCode"))
      document.getElementById("Insurance").disabled = true;
      }

      
    } else if(sessionStorage.getItem("userTypeCodeGlobal") === "3" && sessionStorage.getItem("orgTypeCodeGlobal") === "G") {
     
      var x = document.getElementById("userType");
      var option = document.createElement("option"); 
      option.text = "Block/SubDistrict";
      option.value = "4"
      x.add(option);

      getStates()
      handleState(Number(sessionStorage.getItem("stateNameGlobal")))
      setStateValue(sessionStorage.getItem("stateNameGlobal"))
      setDistrictValue(sessionStorage.getItem("districtCodeGlobal"))
      // handleDistrict(sessionStorage.getItem("districtCodeGlobal"))
      handleSubDistrict(sessionStorage.getItem("districtCodeGlobal"))
      document.getElementById("State").disabled = true;
      document.getElementById("District").disabled = true;

    } else if(sessionStorage.getItem("userTypeCodeGlobal") === "4") {
    
      var x = document.getElementById("userType");
      var option = document.createElement("option"); 
      option.text = "Surveyor";
      option.value = "5"
      x.add(option);

      getStates()
      handleState(Number(sessionStorage.getItem("stateNameGlobal")))
      setStateValue(sessionStorage.getItem("stateNameGlobal"))
      setDistrictValue(sessionStorage.getItem("districtCodeGlobal"))
      // handleDistrict(sessionStorage.getItem("districtCodeGlobal"))
      handleSubDistrict(sessionStorage.getItem("districtCodeGlobal"))

      setBlockValue(sessionStorage.getItem("blockCodeGlobal"))
      document.getElementById("State").disabled = true;
      document.getElementById("District").disabled = true;
      document.getElementById("Block").disabled = true;

      if(sessionStorage.getItem("InsuranceCode")) {
        setInsuranceCompanyValue(sessionStorage.getItem("InsuranceCode"))
      document.getElementById("Insurance").disabled = true;
      }


    } else if(sessionStorage.getItem("userTypeCodeGlobal") === "3" && sessionStorage.getItem("orgTypeCodeGlobal") === "I") {
      var x = document.getElementById("userType");
      var option = document.createElement("option"); 
      option.text = "Block";
      option.value = "4"
      x.add(option);
      getStates()
      handleState(Number(sessionStorage.getItem("stateNameGlobal")))
      setStateValue(sessionStorage.getItem("stateNameGlobal"))
      setDistrictValue(sessionStorage.getItem("districtCodeGlobal"))
       handleSubDistrict(sessionStorage.getItem("districtCodeGlobal"))
      document.getElementById("State").disabled = true;
      document.getElementById("District").disabled = true;

      if(sessionStorage.getItem("InsuranceCode")) {
        setInsuranceCompanyValue(sessionStorage.getItem("InsuranceCode"))
      document.getElementById("Insurance").disabled = true;
      }

    }

   

  }, [])

  useEffect(() => {
    // useEffect to set defaultValue in dropdown meun
    if (state) {
      console.log("state", state)
      setStateValue(state.cropSurveyCode.stateCode)
      setUserTypeValue(state.cropSurveyCode.userTypeCode)
      setUserRoleValue(state.cropSurveyCode.userRoleCode)
      setUserName(state.cropSurveyCode.userName);
       setUserId(state.cropSurveyCode.userId);
      setMobileNumber(state.cropSurveyCode.mobile);
      setAadharNumber(state.cropSurveyCode.aadhar);
      setEmailId(state.cropSurveyCode.emailId);
      setPassword(state.cropSurveyCode.password);
      getUserRole(state.cropSurveyCode.userTypeCode) 
      // setConfirmPassword(state.cropSurveyCode.password);
      setUserCode(state.cropSurveyCode.userCode);
      setOtp(state.cropSurveyCode.otp);
      state.cropSurveyCode.isMobileVerified === "Yes" ? setMobileVerify(true) : setMobileVerify(false)
      setLevel(state.cropSurveyCode.orgTypeCode);

      console.log("value@@@ user tpye code", sessionStorage.getItem("userTypeCodeGlobal"), typeof(sessionStorage.getItem("userTypeCodeGlobal")))
      console.log("value@@@ ins code", sessionStorage.getItem("InsuranceCode"), typeof(sessionStorage.getItem("InsuranceCode")))
      if(sessionStorage.getItem("userTypeCodeGlobal") === "1" && sessionStorage.getItem("InsuranceCode") === "") {
        console.log("sessionStorage.getItem", sessionStorage.getItem("userTypeCodeGlobal") === "1")
            handleLevel(state.cropSurveyCode.orgTypeCode)
      }
     

      getUserType();
      let schemelocalValue = localStorage.getItem("schemeCodeSingle");
      // getUserRole(schemelocalValue, "call");
      getStates();
      getDepartment();
      getScheme();
      getDesignation();
    

      handleState(state.cropSurveyCode.stateCode);
      // handleDistrict(state.cropSurveyCode.districtCode);

      handleSubDistrict(
        // state.cropSurveyCode.subDistrictCode,
        state.cropSurveyCode.districtCode
      );
      setBlockValue(state.cropSurveyCode.blockCode);
      setVillageValue(state.cropSurveyCode.villageCode);
      handleBlock(
        state.cropSurveyCode.subDistrictCode,
        state.cropSurveyCode.districtCode
      );
  
      // setUserTypeValue(state.cropSurveyCode.userTypeCode);
      setUserRoleValue(state.cropSurveyCode.userRoleCode);
      setDesignationValue(state.cropSurveyCode.designationCode);
      setDistrictValue(state.cropSurveyCode.districtCode);
      setGender(state.cropSurveyCode.gender);
      setVisibility(state.cropSurveyCode.isVisible);
      setIsActive(state.cropSurveyCode.isActive);
      setStateValue(state.cropSurveyCode.stateCode);
      setDepartmentValue(state.cropSurveyCode.departmentCode);
      setSchemeValue(schemelocalValue);
      setSubDistrictValue(state.cropSurveyCode.subDistrictCode);
      setBlockValue(state.cropSurveyCode.blockCode);
      setVillageValue(state.cropSurveyCode.villageCode);
      setInsuranceCompanyValue(state.cropSurveyCode.insuranceCompanyCode)
     
    }
  }, []);

  function getUserType() {
    const fetchUserType = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/usertype`
      );
      setUserTypeData(result.data.dataContent);
    };
    fetchUserType();
  }

  function getUserRole(value, call) {
   console.log("schemevalue", value)
    const fetchUserRole = async () => {
      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/userrole/GetUserRolebySchemeCode` , {  
        "schemeCode": 1,
        "userTypeCode": state ? value : userTypeValue,
        "orgLevelCode": sessionStorage.getItem("orgTypeCodeGlobal")
      }
      );
      setUserRoleData(result.data.dataContent);
    };

    if(state) {
      fetchUserRole()

    }else {
      if(userTypeValue && level ) {
        fetchUserRole();
      }else {
        alert("First Select Organization Level and User Level")
      }   

    }

    

  }

  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Cropicstates`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function getDepartment() {
    const fetchDepartment = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/department`
      );
      setDepartmentData(result.data.dataContent);
    };
    fetchDepartment();
  }
  function getScheme() {
    const fetchScheme = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/scheme`
      );

      let filterResult = result.data.dataContent.filter(function (el) { return String(el.schemeCode) === localStorage.getItem("schemeCodeSingle")})
      setSchemeData(filterResult);
    };
    fetchScheme();
  }

  function getDesignation() {
    const fetchDesignation = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/designation`
      );
      setDesignationData(result.data.dataContent);
    };
    fetchDesignation();
  }

  function handleState(value) {
     if(value === "NA") { return}
    setStateValue(value);
    setDistrictData([]);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Cropicdistrict`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }
  // function handleDistrict(value) {
  //   if(value === "NA") { return}
  //   //setStateValue(value);
  //   //setDistrictValue([])
  //   setDistrictValue(value);

  //   var myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");

  //   var raw = JSON.stringify({
  //     DistrictCode: Number(value),
  //   });

  //   var requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${
  //       process.env.NODE_ENV === "development"
  //         ? process.env.REACT_APP_DEV_MODE
  //         : process.env.REACT_APP_PRO_MODE
  //     }/api/subdistrict`,
  //     requestOptions
  //   )
  //     .then((response) => response.text())
  //     .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
  //     .catch((error) => console.log("error", error));
  // }
  function handleSubDistrict(value, DDValue) {
    setDistrictValue(value);

    if(sessionStorage.getItem("userTypeCodeGlobal") === "1") { return}
    if(value === "NA") { return}
    if (value != null) {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: value,
      });
    } else {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: districtValue,
      });
     }

    setSubDistrictValue(value);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/CropicLevel4`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setBlockData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }
  function handleBlock(subDvalue, DValue) {
    // if(value === "NA") { return}
    if (subDvalue != null && DValue != null) {
      var raw = JSON.stringify({
        // subdistrictcode: subDvalue,
        districtcode: DValue,
      });
    } else {
      var raw = JSON.stringify({
        // subdistrictcode: subDistrictValue,
        districtcode: districtValue,
      });
    }
    
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/CropicLevel4`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => setVillageData(JSON.parse(result).dataContent))
        .catch((error) => console.log("error", error));
    
  }

  

  function AddNewUserDB() {
   let valid = false;

   if(userName === "") {
    valid = false;
    alert("Enter Correct User Name")
    return;
   }else {
    valid = true
   }
   
    if(document.getElementById("emailid").style.borderColor === "red" || document.getElementById("emailid").value.length === 0) {
        valid = false;
       
       alert("Enter Correct Email Address")
       return ;
    }else {
        valid = true
    }
    if(document.getElementById("mobilenumber").style.borderColor === "red" || document.getElementById("mobilenumber").value.length === 0) {
        valid = false;
       alert("Enter Correct Mobile Number")
      return;

    }else {
        valid = true
       
    }
    // if(document.getElementById("aadharnumber").style.borderColor === "red") {
    //     valid = false;
    //    alert("Enter Correct Aadhar Number")
    // }else {
    //     valid = true
    // }
    // if(document.getElementById("password").value == document.getElementById("confirmPassword").value || document.getElementById("password").value.length === 0) {
    //     valid = true;
       
    // }else {
    //     valid = false;
    //     alert("Password and Confirm Password does not match")
    // }

    if(userName === "" || userTypeValue === "" || userTypeValue === "Choose..." || userRoleValue === "Choose..." || userRoleValue === "" ||  gender === "" || level === "" || designationValue === "" || designationValue === "Choose..."  ) {
      alert("Enter all required fields")
    
      valid = false;
      return;
    }else {
      valid = true;
     
    }

    if(mobileVerify === false) {
      alert("Verify mobile number")
      valid = false;
     return;
    } else {
      valid = true;
    }

    if(valid === true) {
       state ? UpdateUserDB() : AddUserAPICall()
    }

  }

  function AddUserAPICall() {

   
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
   
     "createdByUC": localStorage.getItem("userCodeGlobal"),
     "userRoleCode": userRoleValue,
     "userName": userName,
     "userId": mobileNumber,
     "mobile": mobileNumber,
     "password": password,
     "emailId": emailId,
     "gender": gender,
     "aadhar": "",
     "departmentCode": "0",
     "designationCode": designationValue,
     "stateCode": stateValue,
     "districtCode": districtValue,
     "subDistrictCode": subDistrictValue,
     "blockCode": blockValue,
     "villageCode": "",
     "userTypeCode": userTypeValue,
     "schemeCode": "1",
     "isMobileVerified": mobileVerify ? "Y" : "N", 
     "isEmailVerified": "N",
     "OrgTypeCode":level,
     "InsuranceCompanyCode" : insuranceCompanyValue
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/users`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        alert(JSON.parse(result).message);
        if (JSON.parse(result).success == true) {
          setFlag(true);
          navigate("/usermanagement/users");
        }
      })
      .catch((error) => console.log("error", error));
  }

  function UpdateUserDB() {
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserCode: String(userCode),
      UserName: String(userName),
      UserId: String(userId),
      Mobile: String(mobileNumber),
      EmailId: String(emailId),
      Password: String(password),
      Gender: String(gender),
      Aadhar: String(aadharNumber),
      DepartmentCode: "0",
      DesignationCode: String(designationValue),
      StateCode: String(stateValue),
      DistrictCode: String(districtValue),
      SubDistrictCode: String(subDistrictValue),
      BlockCode: String(blockValue),
      // VillageCode: String(villageValue),
      VillageCode: "0",
      UserTypeCode: String(userTypeValue),
      UserRoleCode: String(userRoleValue),
      modifiedByUC: localStorage.getItem("userCodeGlobal"),
      isVisible: String(visibility),
      isActive: String(isActive),
      schemeCode: "1",
      OTP: "000000",
      IsMobileVerified : mobileVerify ? "Y" : "N", 
      // IsMobileVerified : "Y",
      IsEmailVerified : "N",
      OrgTypeCode: level,
      InsuranceCompanyCode : insuranceCompanyValue
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/users`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        alert(JSON.parse(result).message);
        if (JSON.parse(result).success == true) {
          setFlag(true);
          navigate("/usermanagement/users");
        }
      })
      .catch((error) => console.log("error", error));
  }

  async function fetchData2() {
    const result = await axios(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/users`
    );
    setUsersData(result.data.dataContent);
  }

  function handleResetForm() {
    setUserName("");
    //  setUserId("");
    setMobileNumber("");
    setAadharNumber("");
    // setPassword("");
    // setConfirmPassword("");
    setEmailId("");
    setGender("");
    setUsersData([]);
    setDepartmentData([]);
    setSchemeData([]);
    setDesignationData([]);
    setUserTypeValue("");
    setUserRoleData([]);
    setStatesData([]);
    setDistrictData([]);
    setSubDistrictData([]);
    setBlockData([]);
    setVillageData([]);
    setMobileVerify(false)
  }

  function validateEmail() {
    if (emailId.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      document.getElementById("emailid").style.borderColor = "green";
    } else {
      document.getElementById("emailid").style.borderColor = "red";
    }
  }

  function validateMobile() {
    setMobileVerify(false)
   if (mobileNumber.length === 10) {
      document.getElementById("mobilenumber").style.borderColor = "green";
    } else {
      document.getElementById("mobilenumber").style.borderColor = "red";
    }
  }

  function validateAadhar() {
    if (aadharNumber.length === 12) {
      document.getElementById("aadharnumber").style.borderColor = "green";
    } else {
      document.getElementById("aadharnumber").style.borderColor = "red";
    }
  }

  function validateConfirmPassword() {
    if (document.getElementById("password").value == document.getElementById("confirmPassword").value) {
      document.getElementById("confirmPassword").style.borderColor = "green";
    } else {
      document.getElementById("confirmPassword").style.borderColor = "red";
    }
  }

  function validateMobileNumber() {
    var regmm='^([6-9]{1})([0-9]{9})$';
  var regmob = new RegExp(regmm);
  if(regmob.test(mobileNumber)){
    generateOTP()
  } else {
      alert("Enter Correct Mobile Number")
      return;
  }    
  }

  function generateOTP() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
      "usercode" : localStorage.getItem("userCodeGlobal"),
      "mobileno": mobileNumber
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/otpauth/sendMobileOTP`, requestOptions)
      .then(response => response.json())
      .then(result => {
        alert(result.message)
        if(result.success) {
          setOTPSend(true)
          handleTimer()
        
        }
      })
      .catch(error => console.log('error', error));

      
  }

  function handleTimer() {

    var element = document.getElementById('send_otp_btn');
    element.disabled = true;
    

     var timeLeft = 30;
    var elem = document.getElementById('timer_text');
    
    var timerId = setInterval(countdown, 1000);
    
    function countdown() {
      if (timeLeft == -1) {
        clearTimeout(timerId);
        element.disabled = false;
        elem.innerHTML = ""
      } else {
        elem.innerHTML = "00 : "+timeLeft;
        timeLeft--;
      }
    }

  }

  function verifyMobileNumber(value) {
    console.log("optvalue", mobileOTP)
    if(mobileOTP === "") {
      alert("Enter Valid OTP")
      return;
    }
    var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

var raw = JSON.stringify({
  "mobileno": mobileNumber,
  "OTP": mobileOTP,
  "userCode" : localStorage.getItem("userCodeGlobal")
});

var requestOptions = {
  method: 'POST',
  headers: myHeaders,
  body: raw,
  redirect: 'follow'
};

fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/otpauth/verifyMobileOTP`, requestOptions)
  .then(response => response.json())
  .then(result => {
    alert(result.message)
    if(result.success) {
      setOTPSend(false)
      setMobileVerify(true)
    }

  }
  )
  .catch(error => console.log('error', error));

  }

  function handleUserName(value) {
    const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
    setUserName(valueFinal)
  }

  function handleMobileNumber(value) {
    const valueFinal = value.replace(/\D/g, "");
    setMobileNumber(valueFinal)
  }

  function handleLevel(value) {
    var x = document.getElementById("userType");
    x.innerHTML =""

    var option = document.createElement("option"); 
    option.text = "Choose...";
    option.value = ""
    x.add(option);


    
 
      if(sessionStorage.getItem("InsuranceCode") === "") {
        console.log("inlineRadioUnit2", document.getElementById("inlineRadioUnit2"))
      if(value === "G") {
        var option = document.createElement("option"); 
        option.text = "State";
        option.value = "2"
        x.add(option);
      }else {
        var option2 = document.createElement("option"); 
        option2.text = "Central";
        option2.value = "1"
        x.add(option2)
      }

      }
    setLevel(value)
  }

  return (
    <>
      
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Add New User</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">User Management</li>
              <li className="breadcrumb-item active">Add New User</li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="card dashboard">
            <div className="card-body">
              <form className="g-3 addNewUser">
                <div className="row">
                  <h5 className="formgrouping">Personal Details</h5>
                  <div className="col-md-4">
                    <label htmlFor="UserName" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      placeholder="User Name"
                      onChange={(e) => handleUserName(e.target.value)}
                      // onChange={(e) => setUserName(e.target.value)}
                      value={userName}
                      maxLength={50}
                    />
                  </div>
               

                  <div className="col-md-4">
                    <label htmlFor="emailAddress" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="emailid"
                      required
                      placeholder="Email Address"
                      onChange={(e) => setEmailId(e.target.value)}
                      value={emailId}
                      onKeyUp={validateEmail}
                      maxLength={50}
                    />
                  </div>                

                  {/* <div className="col-md-4">
                    <label htmlFor="AadharNo" className="form-label">
                      Aadhar Number
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="aadharnumber"
                      required
                      placeholder="Aadhar Number"
                      onChange={(e) => setAadharNumber(e.target.value)}
                      value={aadharNumber}
                      onKeyUp={validateAadhar}
                    />
                  </div> */}

                  <div className="col-md-4">
                    <label htmlFor="Designation" className="form-label">
                      Designation
                    </label>
                    <select
                      id="Designation"
                      required
                      className="form-select"
                      onClick={getDesignation}
                      onChange={(e) => setDesignationValue(e.target.value)}
                      value={designationValue}
                    >
                      <option defaultValue>Choose...</option>
                      {designationData.map((item, id) => {
                        return (
                          <option key={id} value={item.desigCode}>
                            {" "}
                            {item.desigName}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="mobileNo" className="form-label">
                      Mobile No.
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="mobilenumber"
                      required
                      placeholder="Mobile No."
                      onChange={(e) => handleMobileNumber(e.target.value)}
                      value={mobileNumber}
                      onKeyUp={validateMobile}
                      maxLength="10"
                    />
                     {/* {mobileVerify ? <span style={{color: 'green'}}>Mobile Number Successfully Verified</span> : 
					OTPSend ?  <div className="d-md-flex justify-content-md-end mt-1">  <input type="button" className="btn btn-success btn-sm" id="resend_otp_btn" value="Resend OTP" onClick={generateOTP} disabled/></div> : 
					  <div className="d-md-flex justify-content-md-end mt-1"><input type="button" className="btn btn-success btn-sm" value="Send OTP" onClick={generateOTP}/></div>} */}
                    {mobileVerify ? <span style={{color: 'green'}}>Mobile Number Successfully Verified</span> : 
					   <div className="d-md-flex justify-content-md-end mt-1"><span id="timer_text"></span><input type="button" className="btn btn-success btn-sm" id="send_otp_btn" value={OTPSend ? "Resend OTP" : "Send OTP"} onClick={validateMobileNumber} /></div>}
					
                    
                   </div>
                  {OTPSend ? 
                  <div className="col-md-4">
                    <label htmlFor="otp" className="form-label">
                      OTP Verification Code
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="otpnumber"
                      required
                      placeholder="Enter OTP"
                      onChange={(e) => setMobileOTP(e.target.value)}
                      // value={aadharNumber}
                      // onKeyUp={validateAadhar}
                    />
                  <div className="d-md-flex justify-content-md-end mt-2"> <input type="button" className="btn btn-success btn-sm" value="Verify" onClick={(e) => verifyMobileNumber(e)}/></div>
                  </div> : '' }

                 
                  <div className="col-md-4">
                    <div className="col-md-12">
                      <label htmlFor="emailAddress" className="form-label">
                        Gender
                      </label>
                    </div>
                    <div className="col-md-12">
                      <div
                        className="form-check form-check-inline"
                        onClick={() => {
                          setGender("Male");
                        }}
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          id="inlineRadio1"
                          value="male"
                          checked={gender === "Male" ? "true" : ""}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio1"
                        >
                          Male
                        </label>
                      </div>
                      <div
                        className="form-check form-check-inline"
                        onClick={() => {
                          setGender("Female");
                        }}
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          id="inlineRadio2"
                          value="female"
                          checked={gender === "Female" ? "true" : ""}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio2"
                        >
                          Female
                        </label>
                      </div>
                      <div
                        className="form-check form-check-inline"
                        onClick={() => {
                          setGender("Transgender");
                        }}
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          id="inlineRadio3"
                          value="transgender"
                          checked={gender === "Transgender" ? "true" : ""}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio3"
                        >
                          Transgender
                        </label>
                      </div>
                    </div>
                  </div>
                  
                  {/* <h5 className="formgrouping">User Credential</h5> */}

                  {/* <div className="col-md-4">
                    <label htmlFor="userid" className="form-label">
                      User Id
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      placeholder="User Id"
                      onChange={(e) => setUserId(e.target.value)}
                      value={userId}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      required
                      id="password"
                      className="form-control"
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="confirmPassword" className="form-label">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      required
                      className="form-control"
                      id="confirmPassword"
                      placeholder="Password"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      value={confirmPassword}
                      onKeyUp={validateConfirmPassword}
                    />
                  </div> */}

                  <h5 className="formgrouping">Official Details</h5>
                 
                 
                  <div className=  {`col-md-4 ${sessionStorage.getItem("userTypeCodeGlobal") === "1" ? "" : "disableradios"}`}>
                  <label htmlFor="Department" className="form-label">
                      Organization Level
                    </label>
                    <br/>
                    <div
                      className="form-check form-check-inline"
                      onClick={() => {
                        handleLevel("G")
                        
                      }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="level"
                        id="inlineRadioUnit"
                        value="G"
                        checked={level === "G" ? "true" : "" }
                        disabled = {sessionStorage.getItem("userTypeCodeGlobal") === "1" && sessionStorage.getItem("InsuranceCode") === "" ? false : true}
                        
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadioUnit"
                      >
                        Government
                      </label>
                    </div>
                    <div
                      className="form-check form-check-inline"
                      onClick={() => {
                        handleLevel("I")
                        
                      }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="level"
                        id="inlineRadioUnit2"
                        value="I"
                        checked={ level === "I" ? "true" : "" }
                        disabled = {sessionStorage.getItem("userTypeCodeGlobal") === "1" && sessionStorage.getItem("orgTypeCodeGlobal") === "G"? false : true}
                      
                      />
                      <label
                        className="form-check-label"
                        htmlFor="inlineRadioUnit2"
                      >
                        Insurance
                      </label>
                    </div>
                  </div>
                 
                  <div className="col-md-4">
                    <label htmlFor="userType" className="form-label">
                      User Level
                    </label>
                    <select
                      id="userType"
                      required
                      className="form-select"
                      // onClick={getUserType}
                      onChange={(e) => setUserTypeValue(e.target.value)}
                      value={userTypeValue}
                    >
                      <option>Choose...</option>
                      {/* {userTypeData.map((item, id) => {
                        return (
                          <option key={id} value={item.userTypeCode}>
                            {" "}
                            {item.userTypeName}
                          </option>
                        );
                      })} */}
                      {/* {level === "G" ?
                       <><option value= "1"> Central Level </option>
                        <option value= "2"> State Level </option>
                        <option value= "3"> District Level </option>
                        <option value= "4"> Block/SubDistrict Level </option>
                        <option value= "5"> Surveyor</option>
                        </>:
                       <> <option value= "2"> State Level </option>
                        <option value= "3"> District Level </option>
                        <option value= "5"> Surveyor</option>
                        </> } */}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="userRoles" className="form-label">
                      User Roles
                    </label>
                    <select
                      id="userRoles"
                      required
                      className="form-select"
                      onClick={getUserRole}
                      onChange={(e) => setUserRoleValue(e.target.value)}
                      value={userRoleValue}
                    >
                      <option defaultValue>Choose...</option>
                      {userRoleData ?userRoleData.map((item, id) => {
                        return (
                          <option key={id} value={item.userRoleCode}>
                            {" "}
                            {item.userRoleName}
                          </option>
                        );
                      }) : ""}
                    </select>
                  </div>
                 {level === "G" ? <div className="col-md-4">
                    <label htmlFor="State" className="form-label" id="StateLabel">
                      State
                    </label>
                    <select
                      id="State"
                      required
                      className="form-select"
                      onClick={getStates}
                      onChange={(e) => handleState(e.target.value)}
                      value={stateValue}
                      name="stateCode"
                    >
                      <option value="NA">Choose...</option>
                      {statesData ? statesData.map((item, id) => {
                        return (
                          <option key={id} value={item.stateCode}>
                            {" "}
                            {item.stateName}
                          </option>
                        );
                      }) : ""}
                    </select>
                  </div> : ""}

                  {
                    level === "I" ?  <div className="col-md-4">
                    <label htmlFor="Insurance" className="form-label" id="InsuranceLabel">
                      Insurance Company
                    </label>
                    <select
                      id="Insurance"
                      required
                      className="form-select"
                      onChange={(e) => setInsuranceCompanyValue(e.target.value)}
                      value={insuranceCompanyValue}
                      name="InsuranceCode"
                    >
                      <option value="NA">Choose...</option>
                      {insuranceCompanyData ? insuranceCompanyData.map((item, id) => {
                        return (
                          <option key={id} value={item.companyCode}>
                            {" "}
                            {item.companyName}
                          </option>
                        );
                      }) : ""}
                    </select>
                  </div> : ""
                  }

                  {
                    Number(sessionStorage.getItem("userTypeCodeGlobal")) >= 1 && sessionStorage.getItem("orgTypeCodeGlobal") === "I" ? <div className="col-md-4">
                    <label htmlFor="State" className="form-label" id="StateLabel">
                      State
                    </label>
                    <select
                      id="State"
                      required
                      className="form-select"
                      onClick={getStates}
                      onChange={(e) => handleState(e.target.value)}
                      value={stateValue}
                      name="stateCode"
                    >
                      <option value="NA">Choose...</option>
                      {statesData ? statesData.map((item, id) => {
                        return (
                          <option key={id} value={item.stateCode}>
                            {" "}
                            {item.stateName}
                          </option>
                        );
                      }) : ""}
                    </select>
                  </div> : ""
                  }
                
                  <div className="col-md-4">
                    <label htmlFor="District" className="form-label" id="DistrictLabel">
                      District
                    </label>
                    <select
                      id="District"
                      className="form-select"
                      onChange={(e) => handleSubDistrict(e.target.value)}
                      value={districtValue}
                    >
                      <option defaultValue value="NA">Choose...</option>

                      {districtData ? districtData.map((item, id) => {
                        return (
                          <option key={id} value={item.districtCode}>
                            {" "}
                            {item.districtName}
                          </option>
                        );
                      }) : ""}
                    </select>
                  </div>
                  {/* <div className="col-md-4">
                    <label htmlFor="subDistrict" className="form-label" id="subDistrictLabel">
                      SubDistrict
                    </label>
                    <select
                      id="subDistrict"
                      className="form-select"
                      onChange={(e) => handleSubDistrict(e.target.value)}
                      value={subDistrictValue}
                    >
                      <option defaultValue value="NA">Choose...</option>

                      {subDistrictData.map((item, id) => {
                        return (
                          <option key={id} value={item.subDistrictCode}>
                            {" "}
                            {item.subDistrictName}
                          </option>
                        );
                      })}
                    </select>
                  </div> */}
                 <div className="col-md-4">
                    <label htmlFor="Block" className="form-label" id="BlockLabel">
                      Block
                    </label>
                    <select
                      id="Block"
                      className="form-select"
                      onClick={handleBlock}
                      onChange={(e) => setBlockValue(e.target.value)}
                      value={blockValue}
                    >
                      <option defaultValue value="NA">Choose...</option>
                      { blockData ? blockData.map((item, id) => {
                        return (
                          <option key={id} value={item.blockCode}>
                            {" "}
                            {item.blockName}
                          </option>
                        );
                      }) : ""}
                    </select>
                  </div> 
                  {/* <div className="col-md-6">
                    <label htmlFor="village" className="form-label">
                      Village
                    </label>
                    <select
                      id="village"
                      className="form-select"
                      onChange={(e) => setVillageValue(e.target.value)}
                      value={villageValue}
                    >
                      <option defaultValue>Choose...</option>
                      {villageData
                        ? villageData.map((item, id) => {
                            return (
                              <option key={id} value={item.villageCode}>
                                {" "}
                                {item.villageName}
                              </option>
                            );
                          })
                        : ""}
                    </select>
                  </div> */}

                  {state && (
                    <>
                      <div className="col-md-4">
                        <div className="col-md-12">
                          <label htmlFor="emailAddress" className="form-label">
                            Visibility
                          </label>
                        </div>
                        <div className="col-md-12">
                          <div
                            className="form-check form-check-inline"
                            onClick={() => {
                              setVisibility("Yes");
                            }}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="visibility"
                              id="Yes"
                              value="option1"
                              checked={visibility === "Yes" ? "true" : ""}
                            />
                            <label className="form-check-label" htmlFor="Yes">
                              Yes
                            </label>
                          </div>
                          <div
                            className="form-check form-check-inline"
                            onClick={() => {
                              setVisibility("No");
                            }}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="visibility"
                              id="No"
                              value="option2"
                              checked={visibility === "No" ? "true" : ""}
                            />
                            <label className="form-check-label" htmlFor="No">
                              No
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div
                          className="form-check"
                          onClick={() => {
                            setIsActive(isActive === "Yes" ? "No" : "Yes");
                          }}
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="gridCheck1"
                            checked={isActive === "Yes" ? "true" : ""}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gridCheck1"
                          >
                            {" "}
                            Is Active{" "}
                          </label>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                    {state ? (
                      <button
                        className="btn btn-success me-md-2"
                        type="button"
                        onClick={AddNewUserDB}
                      >
                        Update
                      </button>
                    ) : (
                      <button
                        className="btn btn-success me-md-2"
                        type="button"
                        onClick={AddNewUserDB}
                      >
                        Save
                      </button>
                    )}

                    <button
                      className="btn btn-outline-primary"
                      type="button"
                      onClick={handleResetForm}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => navigate("/usermanagement/users")}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
     
    </>
  );
};

export default Users;
